import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown/with-html';

import PageHeader from '../PageHeader';

export const PageLayout = ({ title, children, helpText, socialProofText }) => {
  const renderPageHeader = () => {
    return <PageHeader title={title} />;
  };

  const sectionClass = useMemo(() => {
    if (helpText || socialProofText) {
      return 'col col--12/16-large';
    }

    return 'col col--12/16-large';
  }, [helpText, socialProofText]);

  return (
    <div className="row row__center-align mx-0 !mt-0">
      <div className={`${sectionClass} px-0 my-0`}>
        {renderPageHeader()}

        {helpText && (
          <div className="desktop-d-body mt-4">
            <ReactMarkdown source={helpText} linkTarget="_blank" escapeHtml={false} />
          </div>
        )}
        <section className="mt-4">{children}</section>
      </div>
    </div>
  );
};

PageLayout.propTypes = {
  title: PropTypes.string,
  helpText: PropTypes.string,
  socialProofText: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

PageLayout.defaultProps = {
  title: '',
  helpText: null,
  backButton: true,
  socialProofText: null,
  sectionText: '',
  sectionProgress: 0,
};

export default PageLayout;
